export class VideoListNav {
    open: boolean;
    activeList: string | null;

    constructor() {
        this.open = false;
        this.activeList = null;
    }

    openList(key: string): void {
        this.activeList = key;
        this.open = true;
    }

    closeList(): void {
        this.activeList = null;
        this.open = false;
    }
}
